import { WelcomeContainer } from '../styles';
import FormSelectSearchable from '@components/Form/FormSelectSearchable';
import { useCallback, useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useInternationalAccessStore } from '@src/store/admin/international-access';
import SortedTable from './SortedTable';
import { ComponentLoading } from '@components/Loading';
import SearchFilters from './SearchFilters';
import Pagination from './Pagination';
import EditIcon from '@mui/icons-material/Edit';
import CountriesUpdateModal from './Modal';
import { COUNTRIES_LIST } from '@helper/constants/international';


const defaultSearch = {
  paymentType: ""
};

export const tableHeaders= [
  {
    key: 'healthEntityCode',
    name: 'Health Entity',
  },
  {
    key: 'healthEntity',
    name: 'Health Organisation',
  },
  {
    key: 'hospital',
    name: 'Hospital/Facility',
  },
  {
    key: 'activityNameDisplay',
    name: 'Service',
  },
  {
    key: 'countries',
    name: 'Allowed Countries',
  },
];

const RecActivitiesAccess = ({page}) => {
  const hookForm = useForm({
    defaultValues: defaultSearch,
  });

  const store = useInternationalAccessStore((s) => s);
  const paginatedReceivableActivities = useInternationalAccessStore((s) => s.paginatedReceivableActivities);

  const handleSelect = useCallback(
    (item) => {
      console.log(item);
      setSelectedRecActivity(item);
      setShowModal(true)
    },
    [],
  );
  const itemActions = [
    {
      name: 'Edit',
      description: 'Edit countries',
      icon: EditIcon,
      handler: handleSelect,
    },
  ];

  const hasFetched = useRef(false);

useEffect(() => {
  if (!hasFetched.current) {
    console.log("Test")
    store.fetchReceivableActivities(page);
    hasFetched.current = true;
  }
}, []);

  const [showModal, setShowModal]= useState(false)
  const [selectedRecActivity, setSelectedRecActivity] = useState({});

  const COUNTRY_MAP = Object.fromEntries(
    COUNTRIES_LIST.map(({ value, text }) => [value, text])
  );

  return (
    <>
      <div className="row">
      </div>
      {
        <>
        <div className="row">
          <div className="col col-12 col-lg-12">
          <Pagination
          totalRecords={store.totalRecords}
          onPageChange={store.setCurrentRecordPage}
          onRecordsPerPageChange={store.setRecordsPerPage}
          currentPage={store.currentRecordPage}
          recordsPerPage={store.recordsPerPage}
        />
          </div>
          
          </div> 
        <div className="row">
          <div className="col col-12 col-lg-2">
            <SearchFilters />
          </div>
          <div className="col col-12 col-lg-10">
            <SortedTable
              title="Health Entities List"
              data={paginatedReceivableActivities}
              headers={tableHeaders}
              isLoading={false}
              placeholder={'Sorry, we could not find any available records.'}
              itemActions={itemActions}
              cellAlignMiddle
              customValues={{
                countries: (value) => {
                  if (Array.isArray(value)) {
                    return value.map((v) => COUNTRY_MAP[v] || v).join(', ');
                  }
                  return COUNTRY_MAP[value] || value;
                },
              }}
            />
          </div>
        </div>
        <CountriesUpdateModal
          defaultCountries={selectedRecActivity.countries}
          page={page}
          id={selectedRecActivity.SK}
          visible={showModal}
          onClose={() => setShowModal(false)}
        >
        </CountriesUpdateModal>
        </>}
    </>
  );
};

export default RecActivitiesAccess;
